import { render, staticRenderFns } from "./RoadshowIndex.vue?vue&type=template&id=30583321&scoped=true"
import script from "./RoadshowIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RoadshowIndex.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30583321",
  null
  
)

export default component.exports